import useMount from './useMount';

export default useMount;
